import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Input, message } from 'antd';
import { empty } from '../../shared/helpers/generalHelper';
import { pvcLookupCode } from './lib/pvcHelper';
import { validateLookupForDiscount } from './lib/pvcGateHelper';

/**
 * Shared physical-voucher code prompt used by Global Discount OK / Item OK.
 * Fail closed: closes only this dialog; parent stays; onSuccess only when valid.
 */
class PvcCodeModal extends Component {
    static propTypes = {
        visible: PropTypes.bool.isRequired,
        businessId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
            .isRequired,
        posItemDiscountId: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string
        ]).isRequired,
        trxCodes: PropTypes.array,
        onSuccess: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired
    };

    static defaultProps = {
        trxCodes: []
    };

    constructor(props) {
        super(props);
        this.unmounted = false;
        this.state = {
            code: '',
            lookingUp: false
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) {
            this.setState({ code: '', lookingUp: false });
        }
    }

    componentWillUnmount() {
        this.unmounted = true;
    }

    onChangeCode = e => {
        this.setState({ code: e.target.value });
    };

    submit = () => {
        const code = (this.state.code || '').trim();
        if (empty(code)) {
            message.error('Masukkan physical voucher code.');
            return;
        }
        if (!navigator.onLine) {
            message.error('Physical voucher membutuhkan koneksi online.');
            return;
        }

        this.setState({ lookingUp: true });
        pvcLookupCode(this.props.businessId, code)
            .then(row => {
                if (this.unmounted) return;
                const result = validateLookupForDiscount(
                    row,
                    this.props.posItemDiscountId,
                    this.props.trxCodes
                );
                if (!result.ok) {
                    message.error(result.error);
                    this.setState({ lookingUp: false });
                    this.props.onCancel();
                    return;
                }
                this.props.onSuccess(result.code);
            })
            .catch(err => {
                if (this.unmounted) return;
                const errCode =
                    err &&
                    err.response &&
                    err.response.data &&
                    err.response.data.error;
                if (errCode === 'CODE_NOT_FOUND') {
                    message.error('Kode tidak ditemukan.');
                } else {
                    message.error('Gagal cek physical voucher.');
                }
                this.setState({ lookingUp: false });
                this.props.onCancel();
            });
    };

    render() {
        return (
            <Modal
                title="Physical Voucher Code"
                visible={this.props.visible}
                onOk={this.submit}
                onCancel={this.props.onCancel}
                confirmLoading={this.state.lookingUp}
                okText="Apply"
                cancelText="Cancel"
                destroyOnClose
            >
                <p>Promo ini membutuhkan physical voucher code.</p>
                <Input
                    placeholder="Scan / type code"
                    value={this.state.code}
                    onChange={this.onChangeCode}
                    onPressEnter={this.submit}
                    disabled={this.state.lookingUp}
                    autoFocus
                />
            </Modal>
        );
    }
}

export default PvcCodeModal;
